export const checkPaywal = orgId => {
  const asme = '5eba80059652df329a983c9a';
  const asce = '5eba80049652df329a983963';
  const testTts = '62797be296a38fe89d86e441';

  return orgId === asme || orgId === asce || orgId === testTts;
};

export const checkIsAsce = orgId => orgId === '5eba80049652df329a983963';
